<template>
  <div
    class="org-create-form-container ... max-h-[90vh] overflow-y-auto ml-[20rem] mr-[20rem]"
  >
    <form class="space-y-6">
      <!-- Avatar qismi -->
      <div>
        <label class="block text-sm font-medium text-gray-900 mb-2"
          >Profil rasmi
          <span class="text-red-500 mr-1">*</span>
        </label>
        <div
          :class="{
            'border-red-500': errors.avatar,
            'border-gray-300': !errors.avatar,
          }"
          class="relative w-24 h-24 border-2 border-gray-300 rounded-lg overflow-hidden bg-white-50 border-dashed"
        >
          <img
            v-if="avatarPreview"
            :src="avatarPreview"
            class="w-full h-full object-cover"
            alt="Profil rasmi"
          />
          <div v-else class="flex items-center justify-center w-full h-full">
            <img src="@/assets/image/cloud_icon.png" alt="" />
          </div>
          <input
            type="file"
            accept="image/*"
            class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            @change="handleAvatarUpload"
            @input="checkRequired"
            ref="avatarInput"
          />
        </div>
      </div>

      <!-- Banner qismi -->
      <div>
        <label class="block text-sm font-medium text-gray-900 mb-2"
          >Kanal sarlavha rasmi:</label
        >
        <div
          class="relative flex flex-col items-center justify-center w-full h-36 border-2 border-gray-300 rounded-lg bg-white overflow-hidden border-dashed"
          :class="{ 'bg-cover bg-center': bannerPreview }"
          :style="
            bannerPreview ? `background-image: url(${bannerPreview})` : ''
          "
        >
          <div
            v-if="!bannerPreview"
            class="flex flex-col items-center justify-center w-full h-full"
          >
            <img src="@/assets/image/cloud_icon.png" alt="" />
            <div class="text-xs text-gray-500">
              Faylni tanlang yoki shu yerga olib tashlang
            </div>
            <div class="text-xs text-gray-400 mt-1">
              JPEG, PNG, GIF, MP4 formatlari, maksimal hajmi 50 MB gacha
            </div>
            <button
              type="button"
              class="mt-2 px-4 py-1 bg-indigo-500 text-white text-sm rounded-full"
            >
              Faylni tanlang
            </button>
          </div>
          <input
            type="file"
            accept="image/*,video/mp4"
            class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
            @change="handleBannerUpload"
            ref="bannerInput"
          />
        </div>
      </div>

      <!-- Kanal nomi -->
      <div>
        <label
          for="username"
          class="block text-sm font-medium text-gray-900 mb-2"
          >Foydalanuvchi nomi:
          <span class="text-red-500 mr-1">*</span>
        </label>
        <input
          id="username"
          type="text"
          placeholder="Foydalanuvchi nomi"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-[#5856D60D]"
          v-model="username"
          @input="checkRequired"
          :class="{
            'border-red-500 focus:ring-red-500': errors.username,
            'border-gray-300 focus:ring-indigo-500': !errors.username,
          }"
        />
      </div>
      <div>
        <label
          for="channel-name"
          class="block text-sm font-medium text-gray-900 mb-2"
          >Kanal nomi:
          <span class="text-red-500 mr-1">*</span>
        </label>
        <input
          id="channel-name"
          type="text"
          placeholder="Kanal nomi"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-[#5856D60D]"
          v-model="channelName"
          @input="checkRequired"
          :class="{
            'border-red-500 focus:ring-red-500': errors.channelName,
            'border-gray-300 focus:ring-indigo-500': !errors.channelName,
          }"
        />
      </div>

      <!-- Kanal haqida -->
      <div>
        <label
          for="channel-description"
          class="block text-sm font-medium text-gray-900 mb-2"
          >Kanal haqida:
          <span class="text-red-500 mr-1">*</span>
        </label>
        <textarea
          id="channel-description"
          placeholder="Kanal haqida"
          class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 h-24 bg-[#5856D60D]"
          v-model="channelDescription"
          @input="checkRequired"
          :class="{
            'border-red-500 focus:ring-red-500': errors.channelDescription,
            'border-gray-300 focus:ring-indigo-500': !errors.channelDescription,
          }"
        ></textarea>
      </div>

      <!-- Yo'nalishlar -->
      <div>
        <label class="block text-sm font-medium text-gray-900 mb-2"
          >Yo'nalishni tanlang:</label
        >
        <div class="flex flex-wrap gap-2">
          <div
            v-for="(direction, index) in directions"
            :key="index"
            class="px-3 py-1 text-sm rounded-full cursor-pointer transition-colors"
            :class="
              selectedDirections.includes(direction)
                ? 'bg-indigo-100 text-indigo-800'
                : 'bg-gray-100 text-gray-700'
            "
            @click="toggleDirection(direction)"
          >
            {{ direction }}
          </div>
          <div
            class="px-3 py-1 border border-gray-300 text-gray-700 text-sm rounded-full flex items-center justify-center cursor-pointer"
            @click="showAddDirectionInput = true"
            v-if="!showAddDirectionInput"
          >
            <span>+</span>
          </div>
          <div v-if="showAddDirectionInput" class="flex items-center">
            <input
              type="text"
              class="px-3 py-1 border border-gray-300 rounded-full text-sm"
              placeholder="Новое направление"
              v-model="newDirection"
              @keyup.enter="addNewDirection"
              ref="newDirectionInput"
            />
            <button
              type="button"
              class="ml-2 text-indigo-500"
              @click="addNewDirection"
            >
              Qo'shish
            </button>
          </div>
        </div>
      </div>

      <!-- Ijtimoiy tarmoqlar -->
      <div>
        <label class="block text-sm font-medium text-gray-900 mb-2"
          >Ijtimoiy tarmoqlar</label
        >
        <div class="space-y-2">
          <div
            v-for="(link, index) in links"
            :key="index"
            class="flex items-center"
          >
            <input
              type="url"
              placeholder="URL"
              class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-[#5856D60D]"
              v-model="links[index]"
            />
            <button
              v-if="index > 1"
              type="button"
              class="ml-2 text-red-500"
              @click="removeLink(index)"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              >
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
          <button
            type="button"
            @click="addLink"
            class="p-[15px] border border-[#5856D60D] rounded-[15px] bg-[#5856D60D] hover:border-[#5856D61A]"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
          </button>
        </div>
      </div>

      <!-- Submit button -->
      <div
        v-if="isSubmitting"
        class="fixed inset-0 bg-black bg-opacity-30 z-50 flex items-center justify-center"
      >
        <div class="flex flex-col items-center">
          <svg
            class="animate-spin h-8 w-8 text-indigo-600 mb-2"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8v8H4z"
            ></path>
          </svg>
          <p class="text-white text-sm">Yuklanmoqda...</p>
        </div>
      </div>

      <button
        type="submit"
        class="w-full py-3 bg-indigo-500 text-white font-medium rounded-md hover:bg-indigo-600 transition-colors"
        @click.prevent="saveChannel"
      >
        Kanalni saqlash
      </button>
    </form>

    <!-- Success Modal -->
    <div
      v-if="showSuccessModal"
      class="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center"
    >
      <div
        class="bg-white rounded-3xl pl-[3rem] pr-[3rem] pt-[2rem] pb-[2rem] max-w-sm mx-4 text-center shadow-2xl"
      >
        <!-- Icon -->
        <div>
          <div
            class="w-16 h-16 mx-auto rounded-2xl flex items-center justify-center"
          >
            <img src="@/assets/image/logo.jpg" alt="Logo" class="h-8 w-auto" />
          </div>
        </div>

        <!-- Title -->
        <h2 class="text-xl font-semibold text-purple-600 mb-2">
          Snappy Creator
        </h2>

        <!-- Welcome Message -->
        <h3 class="text-2xl font-bold text-gray-900 mb-2">
          Welcome, {{ channelName || "Creator" }}!
        </h3>

        <!-- Subtitle -->
        <p class="text-gray-500 mb-8">You are now, creator!</p>

        <!-- Button -->
        <button
          @click="goToStudio"
          class="w-full py-3 bg-purple-600 hover:bg-purple-700 text-white font-medium rounded-full transition-colors"
        >
          Let's go!
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/http";
import { ElMessage } from "element-plus";

export default {
  data() {
    return {
      avatarPreview: null,
      errors: {},
      bannerPreview: null,
      channelName: "",
      username: "",
      channelDescription: "",
      isSubmitting: false,
      showSuccessModal: false,
      links: ["", ""],
      directions: [
        "Kelajak texnologiyalari",
        "Sog'liq uchun hayot sirlari",
        "Dunyo sayohatlari",
        "Bugungi san'at",
        "Faol sport",
        "Ekologiya sirlari",
        "Kosmosni o'rganish",
        "Sivilizatsiyalar tarixi",
        "Musiqaning guruhlarga ta'siri",
        "Ilmiy kashfiyotlar",
        "Falsafa savollari",
        "Oshpazlik an'analari",
        "Inson psixologiyasi",
        "Uslub va moda",
        "Xalq an'analari",
        "Internet ta'siri",
        "Moliyaviy savodxonlik",
        "Ta'limda texnologiyalar",
        "Sog'liq va fitnes",
        "Ijtimoiy tarmoqlarning ta'siri",
        "Iqlim ta'siri",
      ],
      selectedDirections: [],
      showAddDirectionInput: false,
      newDirection: "",
    };
  },
  methods: {
    checkRequired() {
      this.errors = {}; // har safar yangilash

      if (!this.username) this.errors.username = true;
      if (!this.channelName) this.errors.channelName = true;
      if (!this.channelDescription) this.errors.channelDescription = true;
      if (!this.$refs.avatarInput?.files?.[0]) this.errors.avatar = true;

      // if (Object.keys(this.errors).length > 0) {
      //   ElMessage({
      //     type: "error",
      //     message: "Iltimos, barcha majburiy maydonlarni to‘ldiring !",
      //   });
      // }
    },
    handleAvatarUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.avatarPreview = URL.createObjectURL(file);
      }
    },
    handleBannerUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.bannerPreview = URL.createObjectURL(file);
      }
    },
    addLink() {
      this.links.push("");
    },
    removeLink(index) {
      this.links.splice(index, 1);
    },
    toggleDirection(direction) {
      const index = this.selectedDirections.indexOf(direction);
      if (index === -1) {
        this.selectedDirections.push(direction);
      } else {
        this.selectedDirections.splice(index, 1);
      }
    },
    addNewDirection() {
      if (this.newDirection.trim()) {
        this.directions.push(this.newDirection.trim());
        this.selectedDirections.push(this.newDirection.trim());
        this.newDirection = "";
        this.showAddDirectionInput = false;
      }
    },
    async saveChannel() {
      this.errors = {}; // har safar yangilash

      if (!this.username) this.errors.username = true;
      if (!this.channelName) this.errors.channelName = true;
      if (!this.channelDescription) this.errors.channelDescription = true;
      if (!this.$refs.avatarInput?.files?.[0]) this.errors.avatar = true;

      if (Object.keys(this.errors).length > 0) {
        ElMessage({
          type: "error",
          message: "Iltimos, barcha majburiy maydonlarni to‘ldiring !",
        });
        return;
      } else {
        this.isSubmitting = true;
      }
      try {
        const getFileData = (file) => {
          return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = () => {
              const base64 = reader.result.split(",")[1];
              resolve(base64);
            };
            reader.onerror = reject;
            reader.readAsDataURL(file);
          });
        };

        const avatarFile = this.$refs.avatarInput?.files?.[0];
        const bannerFile = this.$refs.bannerInput?.files?.[0];

        const avatar = avatarFile
          ? {
              fileName: avatarFile.name,
              fileData: await getFileData(avatarFile),
            }
          : null;

        const banner = bannerFile
          ? {
              fileName: bannerFile.name,
              fileData: await getFileData(bannerFile),
            }
          : null;

        const payload = {
          avatar,
          banner,
          username: this.username,
          fullName: this.channelName,
          description: this.channelDescription,
          directions: this.selectedDirections,
          links: this.links.filter((link) => link.trim() !== ""),
        };

        const response = await http.post("/organization/create", payload);

        if (response) {
          this.showSuccessModal = true;
        }
      } catch (error) {
        ElMessage({
          type: "error",
          message: "Xatolik yuz berdi",
        });
        console.error("Upload failed", error);
      } finally {
        this.isSubmitting = false;
      }
    },
    goToStudio() {
      this.showSuccessModal = false;
      this.$router.push("/main/studio");
    },
  },
  watch: {
    showAddDirectionInput(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.newDirectionInput.focus();
        });
      }
    },
  },
};
</script>

<style>
.org-create-form-container {
  max-width: 100%;
  padding: 1.5rem;
  background-color: white;
  border-radius: 0.5rem;
}
</style>
